import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import { useUnmount } from 'react-use';
import omit from 'lodash/omit';
import axios from 'axios';
import { lawsAPIMultipart } from '~api/laws';
import { newsAPIMultipart } from '~api/news';
import { ErrorMessage } from '~components/toast';
import { iconUploadFile, iconLogout } from '~utils/svgIcons';
import './style.scss';

function UserCard({ user, logout, updateUser, isNewsUserLogged, isLawsUserLogged, isUserLogouting, history }) {
    const sourceRef = React.useRef(axios.CancelToken.source());
    const getSourceRef = React.useRef(axios.CancelToken.source());

    const updateUserPhoto = React.useCallback(
        async (apiInstance, id, payload, cancelToken) =>
            await apiInstance()
                .patch(`/users/${id}/`, payload, { cancelToken })
                .then((res) => res)
                .catch((error) => {
                    if (!axios.isCancel(error)) {
                        toast(<ErrorMessage message={`Updating userpic error: ${error.message}`} />);
                        console.error(`Updating userpic error: ${error.message}`);
                        return { error };
                    }
                }),
        []
    );

    const onInputChange = React.useCallback(
        async (event) => {
            if (event.target.files[0]) {
                const formData = new FormData();
                formData.append('photo', event.target.files[0]);

                let newsResponse = null;
                let lawsResponse = null;

                if (isNewsUserLogged) {
                    newsResponse = await updateUserPhoto(newsAPIMultipart, user.newsUser.id, formData, sourceRef.current.token);
                }
                if (isLawsUserLogged) {
                    lawsResponse = await updateUserPhoto(lawsAPIMultipart, user.lawsUser.id, formData, sourceRef.current.token);
                }
                if (isNewsUserLogged && isLawsUserLogged && newsResponse.data && lawsResponse.data) {
                    updateUser({
                        ...omit(user, ['id']),
                        ...omit(newsResponse.data, ['id']),
                        ...omit(lawsResponse.data, ['id']),
                    });
                    return 'ok';
                }
                if (isNewsUserLogged && !isLawsUserLogged && newsResponse.data) {
                    updateUser({ ...omit(user, ['id']), ...omit(newsResponse.data, ['id']) });
                    return 'ok';
                }
                if (isLawsUserLogged && !isNewsUserLogged && lawsResponse.data) {
                    updateUser({ ...omit(user, ['id']), ...omit(lawsResponse.data, ['id']) });
                    return 'ok';
                }
            }
        },
        [updateUser, user, isNewsUserLogged, isLawsUserLogged, updateUserPhoto]
    );

    const logOut = React.useCallback(async () => {
        if (window.confirm('Выйти из аккаунта?')) {
            const isOk = await logout();
            isOk && history.push('/');
        }
    }, [logout, history]);

    useUnmount(() => {
        if (sourceRef.current) {
            sourceRef.current.cancel(`Previous "user update" request was cancelled`);
        }
        if (getSourceRef.current) {
            getSourceRef.current.cancel(`Previous "get user" request was cancelled`);
        }
    });

    return (
        <div className="user-card">
            <div className="user-card__userpic">
                {/* <div className="user-card__online-indicator" /> */}
                <div className={`user-card__user-photo${user.photo ? ' user-card__user-photo--uploded' : ''}`}>
                    <img src={user.photo} alt="" />
                    <div className="user-card__upload">
                        {iconUploadFile}
                        <span>Загрузить</span>
                        <input type="file" name="file" onChange={onInputChange} accept="image/*,image/jpeg" />
                    </div>
                </div>
            </div>

            <div className="user-card__user-info">
                <span className="user-card__username">
                    {user.last_name} {user.first_name}
                </span>
                <span className="user-card__user-position">{user.position}</span>
                <div>
                    <a
                        href={`tel:+${user.phone && user.phone.replace(/[\s+||()]/g, '')}`}
                        className="user-card__user-phone"
                    >
                        {user.phone}
                    </a>
                </div>
                <div>
                    <a href={`mailto:${user.email}`} className="user-card__user-email">
                        {user.email}
                    </a>
                </div>
            </div>
            <button type="button" onClick={logOut} disabled={isUserLogouting}>
                <span>Выйти</span>
                {iconLogout}
            </button>
        </div>
    );
}

UserCard.propTypes = {
    user: PropTypes.shape({
        newsUser: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
        lawsUser: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    }).isRequired,
    logout: PropTypes.func.isRequired,
    updateUser: PropTypes.func.isRequired,
    isNewsUserLogged: PropTypes.bool,
    isLawsUserLogged: PropTypes.bool,
};

export default withRouter(UserCard);



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/user-card/index.js